<template>
    <div class="container">
  
      <div class="agendamiento_fila row" v-if="item">
        <div class="col-md-2">
          <strong class="cap">{{ textoSolicitadoDocumento }} </strong><br><small>{{ textoSolicitado }}</small>
        </div>
        <div class="col-md-2">
          <strong class="cap">{{ textoRespondidoDocumento }} </strong><br><small>{{ textoRespondido }}</small>
        </div>
          <div class="col-md-3">
            <b-link :href="`${urlApi}pdf/cambio-nivel?id=${item.id}`" target="_blank"><b-icon variant="info" icon="file-text" ></b-icon></b-link> <strong class="cap">{{textoCursoAnterior}} </strong> <b-badge variant="light"><strong :title="textoNotaDescripcion" v-if="textoNota" :class="{'text-danger':pierdeNivel, 'text-success':!pierdeNivel}"> {{ textoNota }}</strong></b-badge> <br>
            <span>{{textoFechaFinalizarCurso}}</span>
            
          </div>
          <div class="col-md-2">
            <strong class="cap">{{textoFinalizado}}</strong><br>
            <span v-if="textoFechaAvanceNivel">{{textoFechaAvanceNivel}}</span>
            
          </div>
          <div class="col-md-2">
            <div v-if="textoFinalizado == 'SI'">
              <strong class="cap">{{textoCursoNuevo}}</strong><br>
              <span>{{textoSede}} - {{textoFechaEntregaLibro}}</span><br>
            </div>
          </div>
          <div class="col-md-1">
            <b-link @click="showObservaciones()"><b-icon  :icon="`${observaciones ? 'chevron-compact-up':'chevron-down'}`"></b-icon></b-link>
            
          </div>
          <div class="col-md-12">
            <ProgresoObservaciones ref="observaciones" :curso_id="curso_id" :estudiante_id="estudiante_id"  :template="2" :show="observaciones" :key="`Observaciones-${item.id}`" />
          </div>
      </div>
      
  
    </div>
  </template>
  
  <script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import ProgresoObservaciones from '@/components/Estudiantes/Progreso/ProgresoObservaciones.vue';

    import Vue from 'vue';
  
    export default {
      name: 'DetalleCambioNivelesItem',
      components: {
        ProgresoObservaciones
      },
      props:{
        item: Object,
        estudiante: Object
      },
      data () {
        return {
          cambiando_tema : false,
          urlApi:'',
          observaciones:false
        }
      },
      
      mounted () {
        var url = Vue.http.options.root;
        // var str = url.split("api")
        this.urlApi = url;
      },
      methods:{
        ...mapActions({

        }),
        ...mapMutations({
  
        }),
        recargar(){
          
        },
        formatearFecha(fecha) {
          return this.$moment(fecha, 'MM/DD/YYYY, h:mm:ss a').format('DD/MM/YYYY h:mm:ss a');
        },
        showObservaciones() {
          this.observaciones=!this.observaciones;
          if (this.observaciones) {
            this.$refs['observaciones'].cargarObservaciones();
          }
        }

      },
      computed: {
        ...mapState({

        }),
        ...mapGetters({
          permiso: 'auth/permiso', 
          getSede: 'sedes/getSede',
        }),
        textoSede(){
          if(this.item && this.item.sede){
            let texto = this.item.sede ? this.item.sede.nombre : "";
            return texto
          }
          return ''
        },
        textoCursoAnterior(){
          if(this.item.cursoAnterior && this.item.cursoAnterior.nombre){
            let texto = this.item.cursoAnterior.nivel.codigo + ": " +this.item.cursoAnterior.nombre
            return texto
          }
          return ''
        },
        textoCursoNuevo(){
          if(this.item && this.item.cursoNuevo && this.item.cursoNuevo.nombre){
            let texto = this.item.cursoNuevo.nivel.codigo + ": " +this.item.cursoNuevo.nombre
            return texto
          } else if(this.item && this.item.nivelSiguiente) {
            let texto = this.item.nivelSiguiente.codigo + ": ";
            return texto;
          }
          return ''
        },
        textoFinalizado(){
          if(this.item){
            let texto = this.item.finalizado && this.item.pasa_nivel ? "SI" : "NO";
            return texto
          }
          return ''
        },
        curso_id(){
          if(this.item.cursoAnterior && this.item.cursoAnterior.id){
            return this.item.cursoAnterior.id;
          }
          return null
        },
        estudiante_id() {
          if(this.item && this.item.estudiante_id){
            return this.item.estudiante_id;
          }
          return null
        },
        textoSolicitado(){
          if(this.item && this.item.solicitante){
            let texto = this.item.solicitante.primer_nombre+" "+this.item.solicitante.primer_apellido;
            return texto
          }
          return ''
        },
        textoSolicitadoDocumento(){
          if(this.item && this.item.solicitante){
            let texto = this.item.solicitante.numero_documento;
            return texto
          }
          return ''
        },
        textoRespondido(){
          if(this.item && this.item.administrador && this.item.curso_nuevo_id){
            let texto = this.item.administrador.primer_nombre+" "+this.item.administrador.primer_apellido;
            return texto
          }
          return ''
        },
        textoRespondidoDocumento(){
          if(this.item && this.item.administrador && this.item.curso_nuevo_id){
            let texto = this.item.administrador.numero_documento;
            return texto
          }
          return ''
        },
        textoFechaFinalizarCurso(){
          if(this.item && this.item.fecha_finalizar_curso){
            return this.$moment(new Date(this.item.fecha_finalizar_curso)).format('DD/MM/YYYY h:mm:ss a')
            // let fecha_finalizar_curso = new Date(this.item.fecha_finalizar_curso).toLocaleString()
            // return fecha_finalizar_curso
          }
          return ''
        },
        textoFechaAvanceNivel(){
          if(this.item && this.item.fecha_avance_nivel){
            return this.$moment(new Date(this.item.fecha_avance_nivel)).format('DD/MM/YYYY h:mm:ss a')
            // let fecha_avance_nivel = new Date(this.item.fecha_avance_nivel).toLocaleString()
            // return fecha_avance_nivel
          }
          return ''
        },
        textoNota(){
          if(this.item && this.item.nota_final){
            return this.item.nota_final
          }
          return ''
        },
        textoNotaDescripcion() {
          if(this.item && this.item.nota_final){
            if (this.item.nota_nivelacion) {
              return "Nota nivelación"
            } else {
              return "Nota final"
            }
          }
          return ''
        },
        pierdeNivel() {
          if(this.item && this.item.nota_final){
            return this.item.nota_final < 3;
          }
          return null
        },
        textoFechaEntregaLibro(){
          if(this.item && this.item.fecha_entrega_libro){
            return this.$moment(new Date(this.item.fecha_entrega_libro)).format('DD/MM/YYYY h:mm:ss a')
            // let fecha_entrega_libro = new Date(this.item.fecha_entrega_libro).toLocaleString()
            // return fecha_entrega_libro
          }
          return ''
        },
        
      }
    }
  </script>
  
  <style scope>
  .agendamiento_fila {
      border-top: 1px solid #bbb;
      font-size:14px;
      line-height: 14px;
      padding-top: 10px !important;
  }
  .agendamiento_fila  strong{}
  .agendamiento_fila  span{
    font-size: 10px;
    line-height: 10px;
    color:#888;
    font-style: oblique;
  }
  .agendamiento_fila  p{
        margin-bottom: 5px !important;
  }
  .agendamiento_fila  button{
        margin: 5px !important;
  }
  .cambiar-tema{
    padding: 10px;
      border: 1px solid grey;
  }
  .cap{
  text-transform: capitalize;  
  }
  .success{

  }
  .fail{
    
  }
  </style>